import * as types from 'store/modules/hres96u/mutation-types'
import hres96u from 'api/hres96u'
import swal from 'sweetalert'
import { sendApprove } from 'assets/js/sendApprove.js'
import hres96uLabels from 'assets/labels/hres96u'
import { hres96uMaxRowspan, hres96uColumns } from 'assets/columns/hres96u'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres96uLabels,
    maxRowspan: hres96uMaxRowspan,
    columns: hres96uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {}
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES96U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES96U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES96U_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRES96U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES96U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES96U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES96U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES96U_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES96U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES96U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES96U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES96U_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRES96U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES96U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES96U_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES96U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES96U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES96U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES96U_COLUMNS_LABELS] ({ commit }) {
      hres96u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES96U_COLUMNS, data.labels)
          commit(types.SET_HRES96U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES96U_INDEX] ({ commit }, searchParams) {
      hres96u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES96U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES96U_DETAIL] ({ commit }, searchParams) {
      hres96u.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES96U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES96U_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres96u.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES96U_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres96u/index.js